export const WIZARD_COOKIE_KEY =
  "storydoc_wizard_67ebc42a-0835-47b9-9957-6cd8c3d02ef3";
export const WIZARD_DOCPILOT_COOKIE_KEY = "storydoc_wizard_docpilot_DbGlmuVoG6";
export const WEBSITE_DIRECTORY_COOKIE_KEY =
  "sd-anonymous-website-user-M7u8OPbtoBZ6oLgi2FtTu";
export const WEBSITE_TEMPLATE_COOKIE_KEY =
  "storydoc_template_1b2f942c-1d68-48b2-99df-b40aed30e76c";
